<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="2" epub:type="prologue" id="prologue">
<h1 data-number="2" epub:type="prologue">Prologue</h1>
<p>Ten years had passed since an army of navvies swarmed into the peaceful Border countryside to create an innovation which was to transform the lives of local people, though at first they were reluctant to accept its benefits.</p>
<p>When the navvies tramped away they left as their legacies a road to the outside world in the form of a network of railway lines, a beautiful railway bridge over the river Tweed, an unmarked grave-mound of their dead in the burying-ground of the abbey at Rosewell… and several fatherless children.</p>
<p>This is the story of three of these navvy bastards.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1c0ea9f5